import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import HighlightOff from '@material-ui/icons/HighlightOff';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as Actions from '../actions/quickModeContens';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { Routes, Screens } from '../utils/Routes';
const styles = (theme: Theme) =>
	createStyles({
		menuButton: {
			marginLeft: -12,
			marginRight: 20,
		},
		root: {
			flexGrow: 1,
		},
		title: {
			flex: 1,
			[theme.breakpoints.down('sm')]: {
				fontSize: '1rem',
			},
		},
	});
/**
 * 受講画面の上部バーコンポーネント
 */
class QuickModePreviewBar extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);
		this.backtoContentsCreate = this.backtoContentsCreate.bind(this);
	}

	public render() {
		const { classes, courseName } = this.props;
		return (
			<AppBar position="static" color="default" className={classes.root}>
				<Toolbar>
					<IconButton
						className={classes.menuButton}
						color="inherit"
						aria-label="Menu"
						onClick={this.props.openIndexTree}
					>
						<MenuIcon />
					</IconButton>
					<Typography
						variant="h6"
						color="inherit"
						noWrap={true}
						className={classes.title}
					>
						{courseName}
					</Typography>

					<Button color="inherit" onClick={this.backtoContentsCreate}>
						<HighlightOff />
						<Hidden xsDown={true}>
							{i18n.t('QuickModePreviewBar_0000')}
						</Hidden>
					</Button>
				</Toolbar>
			</AppBar>
		);
	}

	public backtoContentsCreate = () => {
		this.props.reSetCurrentItem();
		const to = Routes.getPath(Screens.QUICK_MODE_TEXT_TEST_CREATE);
		const state = {
			initFlg: true,
		};
		this.props.pushHistoryState(to, state);
	};
}

const mapStateToProps = (state: IRootState) => ({
	courseName: state.quickModeContents.courseName,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	openIndexTree: () => {
		dispatch(Actions.setIndexTree({}));
	},
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	reSetCurrentItem: () => {
		dispatch(Actions.reSetCurrentItem({}));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModePreviewBar);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModePreviewBar.tsx